import React, { useEffect } from "react";
import { Button } from "@speedoc/design-assets";

const SubmissionConfirmation = ({ formHeight, handleBackClick, data }) => {
  useEffect(() => {
    document.querySelector(".sa-success").classList.add("hide");
    setTimeout(() => {
      document.querySelector(".sa-success").classList.remove("hide");
    }, 10);
  }, []);

  const handleClick = () => {
    handleBackClick();
  };

  return (
    <div className="submissionConfirmation">
      <div style={{ height: `${formHeight}px` }}>
        <div className="mid">
          <div className="check_mark">
            <div className="sa-icon sa-success animate">
              <span className="sa-line sa-tip animateSuccessTip" />
              <span className="sa-line sa-long animateSuccessLong" />
              <div className="sa-placeholder" />
              <div className="sa-fix" />
            </div>
          </div>
          <div className="bottom">
            <div />
            <p className="successText">{data?.submissionSuccessText || "We've sent you a link!"}</p>
          </div>
          <Button onClick={handleClick} className="secondary sm">
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionConfirmation;
